import * as React from 'react';
import {FinePrint} from '../Text';

export type RadioHelpTextProps = {
  id?: string;
  children: React.ReactNode;
};

/**
 * Renders the sub-text (or helper text) as part of a <Radio /> component.
 */
export const RadioHelpText = React.forwardRef<any, RadioHelpTextProps>(
  // @ts-expect-error - TS2769 - No overload matches this call.
  (props, forwardedRef) => <FinePrint dim {...props} ref={forwardedRef} />
);

RadioHelpText.displayName = 'RadioHelpText';
